export default __webpack_public_path__ + "static/media/3d_icon.e7b15c8f.svg";